import { Controller } from "@hotwired/stimulus"

// Reveal — mostra/esconde alvos conforme o valor de um campo de controle
// (select, radio, checkbox). Genérico e declarativo via data attributes.
//
// O campo de controle dispara `reveal#update` no input/change. Cada alvo
// declara `data-reveal-when="valor1 valor2"` — fica visível só quando o valor
// atual do controle estiver na lista (espaço separa múltiplos). Sem `when`,
// sempre visível.
//
//   <div data-controller="reveal">
//     <select data-reveal-target="control" data-action="reveal#update">…</select>
//     <div data-reveal-target="item" data-reveal-when="link">…campo URL…</div>
//     <div data-reveal-target="item" data-reveal-when="specific">…multi-select…</div>
//   </div>
//
// COLAPSO/EXPANSÃO DA COLUNA DO CONTROLE
// Um elemento "wrapper" (a coluna que contém o controle) pode encolher quando
// há item visível e expandir quando não há — útil pra um campo que ocupa a
// largura inteira e cede metade ao revelar o campo vizinho. Declare:
//
//   <div data-reveal-target="collapse"
//        data-reveal-collapsed="sm:col-span-1"
//        data-reveal-expanded="sm:col-span-2">…select…</div>
//
// `collapsed` é aplicado quando algum item está visível; `expanded` quando não.
export default class extends Controller {
  static targets = ["control", "item", "collapse"]

  connect() {
    this.update()
  }

  update() {
    const value = this.controlValue()
    let anyVisible = false
    this.itemTargets.forEach((item) => {
      const whenAttr = item.dataset.revealWhen
      const show = !whenAttr || whenAttr.split(/\s+/).includes(value)
      item.hidden = !show
      if (show) anyVisible = true
    })
    this.syncCollapse(anyVisible)
  }

  // Alterna as classes de largura da coluna do controle conforme há item visível.
  syncCollapse(anyVisible) {
    this.collapseTargets.forEach((el) => {
      const collapsed = (el.dataset.revealCollapsed || "").split(/\s+/).filter(Boolean)
      const expanded  = (el.dataset.revealExpanded || "").split(/\s+/).filter(Boolean)
      const add    = anyVisible ? collapsed : expanded
      const remove = anyVisible ? expanded : collapsed
      el.classList.remove(...remove)
      el.classList.add(...add)
    })
  }

  controlValue() {
    const control = this.hasControlTarget ? this.controlTarget : null
    if (!control) return null
    // radios: o valor é o checado dentro do grupo
    if (control.type === "radio") {
      const checked = this.controlTargets.find((c) => c.checked)
      return checked ? checked.value : null
    }
    return control.value
  }
}
